import React from 'react';

export default function ApiCallSettings({ cfg, update }) {
  return (
    <div className="mt-2 grid gap-2">
      <div className="grid gap-2 grid-cols-1 sm:grid-cols-2">
        <label className="grid gap-1 text-xs text-slate-700">
          Method
          <select className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.method} onChange={(e) => update({ method: e.target.value })}>
            {['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </label>
        <label className="grid gap-1 text-xs text-slate-700">
          Auth Type
          <select className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.authType} onChange={(e) => update({ authType: e.target.value })}>
            <option value="none">None</option>
            <option value="bearer">Bearer</option>
            <option value="basic">Basic</option>
            <option value="api_key">API Key</option>
          </select>
        </label>
      </div>

      <label className="grid gap-1 text-xs text-slate-700">
        URL
        <input className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.url} onChange={(e) => update({ url: e.target.value })} />
      </label>

      {cfg.authType !== 'none' ? (
        <label className="grid gap-1 text-xs text-slate-700">
          Credential / Token
          <input className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.token} onChange={(e) => update({ token: e.target.value })} />
        </label>
      ) : null}

      <div className="grid gap-2 grid-cols-1 sm:grid-cols-2">
        <label className="grid gap-1 text-xs text-slate-700">
          Timeout (ms)
          <input className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" type="number" min="1000" value={cfg.timeoutMs} onChange={(e) => update({ timeoutMs: Number(e.target.value) })} />
        </label>
        <label className="grid gap-1 text-xs text-slate-700">
          Retry Count
          <input className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" type="number" min="0" max="5" value={cfg.retryCount} onChange={(e) => update({ retryCount: Number(e.target.value) })} />
        </label>
      </div>

      <label className="grid gap-1 text-xs text-slate-700">
        Headers JSON
        <textarea className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" rows={3} value={cfg.headersJson} onChange={(e) => update({ headersJson: e.target.value })} />
      </label>
      <label className="grid gap-1 text-xs text-slate-700">
        Query JSON
        <textarea className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" rows={3} value={cfg.queryJson} onChange={(e) => update({ queryJson: e.target.value })} />
      </label>
      <label className="grid gap-1 text-xs text-slate-700">
        Body JSON
        <textarea className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" rows={3} value={cfg.bodyJson} onChange={(e) => update({ bodyJson: e.target.value })} />
      </label>

      <div className="grid gap-2 grid-cols-1 sm:grid-cols-2">
        <label className="grid gap-1 text-xs text-slate-700">
          Success Variable
          <input className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.successVariable} onChange={(e) => update({ successVariable: e.target.value })} />
        </label>
        <label className="grid gap-1 text-xs text-slate-700">
          Save Response As (Legacy)
          <input className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.saveResponseAs || ''} onChange={(e) => update({ saveResponseAs: e.target.value })} />
        </label>
      </div>

      <div className="grid gap-2 grid-cols-1 sm:grid-cols-2">
        <label className="grid gap-1 text-xs text-slate-700">
          Error Variable
          <input className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.errorVariable} onChange={(e) => update({ errorVariable: e.target.value })} />
        </label>
      </div>

      <label className="grid gap-1 text-xs text-slate-700">
        On Failure
        <select className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20" value={cfg.failStrategy} onChange={(e) => update({ failStrategy: e.target.value })}>
          <option value="continue">Continue</option>
          <option value="stop">Stop</option>
          <option value="route_to_fallback">Route to fallback</option>
        </select>
      </label>
    </div>
  );
}
